// extracted by mini-css-extract-plugin
module.exports = {"input-select":"InputSearch_input-select__2Cg0u","input-select__clear":"InputSearch_input-select__clear__3AzvT","input-select__search":"InputSearch_input-select__search__nXy7T"};